import { React, useState } from "react";
import { Link as RouterLink } from "react-router";
import { useTranslation } from "react-i18next";
import { MainMenuDrawer } from "~/components/Layout/MainMenuDrawer";
import { Modal } from "~/components/Modal/Modal";
import { useSignOut } from "~/hooks/useSignout";
import MenuIcon from "~/content/icons/menu.svg?react";
import logo from "~/content/images/logo.svg";

import "./MainHeader.css";

export function MainHeader() {
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showGetHelpModal, setShowGetHelpModal] = useState(false);
  const signout = useSignOut();

  function openGetHelpModal() {
    setShowGetHelpModal(true);
  }

  function closeGetHelpModal() {
    setShowGetHelpModal(false);
  }

  async function handleLogout() {
    await signout();
  };

  return (
    <>
      <header className="main-header">
        <RouterLink to="/" className="main-header__logo">
          <img
            src={logo}
            alt="Viedoc Me Logo"
            className="main-header__logo-image"
            height="24px"
            width="150px"
          />
        </RouterLink>
        <Modal
          isOpen={showGetHelpModal}
          onClose={closeGetHelpModal}
          title={t("general.help.get_help")}
        >
          {t("getHelp.info")}
        </Modal>
        <button
          className="main-header__menu-button"
          onClick={() => setDrawerOpen(true)}
          aria-label="Open menu"
          type="button"
        >
          <MenuIcon className="main-header__menu-button-icon" />
        </button>
      </header>
      <MainMenuDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onShowGetHelpModal={openGetHelpModal}
        onLogout={handleLogout}
      />
    </>
  );
}
